import { Injectable } from '@angular/core';

// import {CrudService} from '@dash/randy/dashboard/services/crud.service';
// import {CollectionItemModel} from '../classes/collection-item.model';
//
// @Injectable({
//     providedIn: 'root'
// })
// export class CollectionItemService extends CrudService<CollectionItemModel> {
//     constructor() {
//         super('collectionItem');
//     }
// }
import { CollectionItemModel, ItemLockStatus, TermData } from '../classes/collection-item.model';
import { DBCrudService } from '@dash/randy/dashboard/services/db-crud.service';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthorizationService } from '../../../../security/service/authorization.service';
import { delay, lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CollectionItemService extends DBCrudService<CollectionItemModel> {
  constructor(
    protected router: Router,
    protected http: HttpClient,
    protected authorizationService: AuthorizationService,
  ) {
    super('collectionitems', router, http, authorizationService);
  }

  getAllItemsWithSelector(list: boolean = false): Promise<CollectionItemModel[]> {
    console.log(list, 'List');
    return this.getAllObjects('?type=' + (list ? 'List' : 'Object'));
  }

  async getAllListsOfCollectionItem(
    collectionItemId: string,
  ): Promise<{ listIds: string[]; templates: { id: string; collectionItemIds: string[] }[] }> {
    console.log('Get all lists of a collection item', collectionItemId);
    if (!collectionItemId) {
      return Promise.resolve({ listIds: [], templates: [] });
    }
    return lastValueFrom(
      this.http.get<{ listIds: string[]; templates: { id: string; collectionItemIds: string[] }[] }>(
        `${this.apiUrl}/${collectionItemId}/lists`,
      ),
    );
  }

  async getListAndObjects(): Promise<{ hasCustomId: boolean; items: CollectionItemModel[] }> {
    let hasCustomId = false;
    const lists$ = this.getAllItemsWithSelector(true);
    const objects$ = this.getAllItemsWithSelector(false);

    const lists = await lists$;
    const objects = await objects$;
    lists.map(row => {
      row.o = false;
      delete row.type;

      if (row.valueRoots.length === 1 && row.valueRoots[0].values.length === 1) {
        row.customId = row.valueRoots[0].values[0].data['number'];
      }
      return row;
    });

    objects.map(row => {
      row.o = true;
      delete row.type;
      if (row.valueRoots.length === 1 && row.valueRoots[0].values.length === 1) {
        if (!hasCustomId) hasCustomId = true;
        row.customId = row.valueRoots[0].values[0].data['number'];
      }
      return row;
    });
    return { items: objects.concat(lists), hasCustomId };
  }

  async getLockStatus(collectionItemId: string): Promise<ItemLockStatus> {
    if (!collectionItemId) {
      return Promise.reject('No collection item id');
    }
    return new Promise((resolve, reject) =>
      this.http.get<ItemLockStatus>(`${this.apiUrl}/${collectionItemId}/lock`).subscribe(
        data => {
          resolve(data);
        },
        error => {
          reject(error);
        },
      ),
    );
  }

  async setLockStatus(collectionItemId: string, force: boolean = false): Promise<ItemLockStatus> {
    if (!collectionItemId) {
      return Promise.reject('No collection item id');
    }
    return new Promise((resolve, reject) =>
      this.http
        .post<ItemLockStatus>(`${this.apiUrl}/${collectionItemId}/lock`, {
          force: force,
        })
        .subscribe(
          data => {
            resolve(data);
          },
          error => {
            reject(error);
          },
        ),
    );
  }

  async removeLockStatus(collectionItemId: string): Promise<ItemLockStatus> {
    if (!collectionItemId) {
      return Promise.reject('No collection item id');
    }

    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };

    return new Promise((resolve, reject) =>
      this.http.delete<ItemLockStatus>(`${this.apiUrl}/${collectionItemId}/lock`, httpOptions).subscribe(
        data => {
          resolve(data);
        },
        error => {
          reject(error);
        },
      ),
    );
  }

  async changeHiddenStatus(collectionItemId: string, newHiddenValue: boolean): Promise<CollectionItemModel> {
    if (!collectionItemId) {
      return Promise.reject('No collection item id provided');
    }
    return new Promise<CollectionItemModel>((resolve, reject) =>
      this.http
        .put(`${this.apiUrl}/${collectionItemId}/hidden`, {
          value: newHiddenValue,
        })
        .subscribe(
          data => {
            resolve(data);
          },
          error => {
            reject(error);
          },
        ),
    );
  }

  async addValueGroup(collectionItemId: string, templateGroupId: string): Promise<CollectionItemModel> {
    if (!collectionItemId || !templateGroupId) {
      return Promise.reject('No collection item id or template group id');
    }
    return new Promise<CollectionItemModel>((resolve, reject) =>
      this.http
        .post(`${this.apiUrl}/${collectionItemId}/valuegroups`, {
          templateGroupId: templateGroupId,
        })
        .subscribe(
          data => {
            resolve(data);
          },
          error => {
            reject(error);
          },
        ),
    );
  }

  async removeValueGroup(collectionItemId: string, valueGroupId: string): Promise<CollectionItemModel> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    if (!collectionItemId || !valueGroupId) {
      return Promise.reject('No collection item id or value group id');
    }
    return new Promise<CollectionItemModel>((resolve, reject) =>
      this.http.delete(`${this.apiUrl}/${collectionItemId}/valuegroups/${valueGroupId}`, httpOptions).subscribe(
        data => {
          resolve(data);
        },
        error => {
          reject(error);
        },
      ),
    );
  }

  async addValueRoot(collectionItemId: string, fieldRootId: string, valueGroupId?: string): Promise<CollectionItemModel> {
    if (!collectionItemId || !fieldRootId) {
      return Promise.reject('No collection item id or value root id');
    }
    return new Promise<CollectionItemModel>((resolve, reject) =>
      this.http
        .post(`${this.apiUrl}/${collectionItemId}/valueroots`, {
          fieldRootId: fieldRootId,
          valueGroupId: valueGroupId,
        })
        .subscribe(
          data => {
            resolve(data);
          },
          error => {
            reject(error);
          },
        ),
    );
  }

  async removeValueRoot(collectionItemId: string, valueRootId: string): Promise<CollectionItemModel> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    if (!collectionItemId || !valueRootId) {
      return Promise.reject('No collection item id or value root id');
    }
    return new Promise<CollectionItemModel>((resolve, reject) =>
      this.http.delete(`${this.apiUrl}/${collectionItemId}/valueroots/${valueRootId}`, httpOptions).subscribe(
        data => {
          resolve(data);
        },
        error => {
          reject(error);
        },
      ),
    );
  }

  async extendLockStatus(collectionItemId: string): Promise<ItemLockStatus> {
    if (!collectionItemId) {
      return Promise.reject('No collection item id');
    }
    return new Promise((resolve, reject) =>
      this.http.post<ItemLockStatus>(`${this.apiUrl}/${collectionItemId}/lock`, {}).subscribe(
        data => {
          resolve(data);
        },
        error => {
          reject(error);
        },
      ),
    );
  }

  async cloneObject(itemId: string, amount: number = 1): Promise<string[]> {
    if (!itemId) {
      return Promise.reject('No collection item id');
    }
    return new Promise((resolve, reject) =>
      this.http
        .post<{ collectionItemIds: string[] }>(`${this.apiUrl}/${itemId}/clone`, { amount: amount })
        .pipe(delay(5000))
        .subscribe({
          next: data => {
            resolve(data.collectionItemIds.map(id => id));
          },
          error: error => {
            reject(error);
          },
        }),
    );
  }

  async addObject(object: CollectionItemModel): Promise<any> {
    // if (typeof object.collection === 'number') {
    //   let collection = await this.collectionStore.select(getItemById(object.collection)).subscribe((collection) => {
    //       object = {...object};
    //       object.collection = collection;
    //     }
    //   );
    // }

    object = { ...object };
    // object.collectionIds = [];
    // for (const collection of object.collections) {
    //   if ('id' in collection) {
    //     object.collectionIds.push(collection.id);
    //   } else {
    //     console.error(collection, 'couldnt found an ID');
    //   }
    // }
    console.log(object, 'Collection item with id');
    return super.addObject(object);
  }

  async updateObject(object: CollectionItemModel): Promise<any> {
    // if (typeof object.collection === 'number') {
    //   let collection = await this.collectionStore.select(getItemById(object.collection)).subscribe((collection) => {
    //       object = {...object};
    //       object.collection = collection;
    //     }
    //   );
    // }
    object = { ...object };
    object.valueRoots = null;

    // remove the groups property since it is not needed for the update and can cause issues if it contains data
    delete object.valueGroups;

    return super.updateObject(object);
  }

  async updateTermsOfCollectionItem(collectionItemId: string, terms: TermData[]): Promise<CollectionItemModel> {
    return new Promise((resolve, reject) =>
      this.http.put(`${this.apiUrl}/${collectionItemId}/terms`, { terms: terms }).subscribe({
        next: data => {
          resolve(data);
        },
        error: error => {
          reject(error);
        },
      }),
    );
  }
}
